import { render, staticRenderFns } from "./changeSonPassWord.vue?vue&type=template&id=1b2d8d2c&"
import script from "./changeSonPassWord.vue?vue&type=script&lang=js&"
export * from "./changeSonPassWord.vue?vue&type=script&lang=js&"
import style0 from "./changeSonPassWord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports